import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import AuthenticatedLayout from "./AuthenticatedLayout";
import RequiredPasswordChangePage from "../pages/RequiredPasswordChangePage";
import { AUTHENTICATED_SESSION_KEY } from "./sessionEvents";

const ProtectedRoute = ({ children }) => {
  const { loading, authenticated, authError, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return <p className="p-6 text-center">Checking authentication…</p>;
  }

  if (authError && !authenticated) {
    return (
      <p className="p-6 text-center text-red-800">
        The backend is currently unavailable. Please try again later.
      </p>
    );
  }

  if (!authenticated) {
    let previouslyAuthenticated = false;
    try {
      previouslyAuthenticated =
        window.sessionStorage.getItem(AUTHENTICATED_SESSION_KEY) === "true";
    } catch {
      // Continue with a normal login redirect when browser storage is unavailable.
    }
    return (
      <Navigate
        to="/login"
        replace
        state={{ sessionExpired: previouslyAuthenticated, from: location }}
      />
    );
  }

  return (
    <AuthenticatedLayout>
      {user?.mustChangePassword ? <RequiredPasswordChangePage /> : children}
    </AuthenticatedLayout>
  );
};

export default ProtectedRoute;
